import { render, staticRenderFns } from "./ProgressShareComp.vue?vue&type=template&id=1d04202e&scoped=true&"
import script from "./ProgressShareComp.vue?vue&type=script&lang=ts&"
export * from "./ProgressShareComp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d04202e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
